import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	opsgenieSchedulePageTitle: {
		id: 'opsgenie-schedule.common.opsgenie-schedule-page-title',
		defaultMessage: 'Opsgenie Schedule',
		description: 'The Opsgenie schedule page title',
	},
	opsgenieSchedulePageHeader: {
		id: 'opsgenie-schedule.common.opsgenie-schedule-page-header',
		defaultMessage: 'On-call',
		description: 'The Opsgenie schedule page header',
	},
	opsgenieScheduleHeaderInfo: {
		id: 'opsgenie-schedule.common.opsgenie-schedule-header-info',
		defaultMessage: "See your team's on-call info including schedules and rotations.",
		description: 'The Opsgenie schedule page header information',
	},
	opsgenieScheduleExampleScheduleTitle: {
		id: 'opsgenie-schedule.common.opsgenie-schedule-example-schedule-title',
		defaultMessage: 'Your example schedule',
		description: 'The example schedule title on the on-call schedule page in next-gen project.',
	},
	opsgenieScheduleExampleSchedulePoweredBy: {
		id: 'opsgenie-schedule.common.opsgenie-schedule-example-schedule-powered-by',
		defaultMessage: 'Powered by',
		description: 'The powered by text on the on-call schedule page in next-gen project.',
	},
	opsgenieScheduleDataLoadingError: {
		id: 'opsgenie-schedule.common.opsgenie-schedule-data-loading-error',
		defaultMessage: 'Failed to load schedule data from Opsgenie',
		description: 'Error message displayed when the schedule data from Opsgenie fails to load',
	},

	noOpsgenieTeamTitle: {
		id: 'opsgenie-schedule.common.no-opsgenie-team-title',
		defaultMessage: 'Connect an Opsgenie team',
		description:
			'Title of empty state when no Opsgenie team has been connected to this jira project',
	},
	noOpsgenieTeamBodyAdmin: {
		id: 'opsgenie-schedule.common.no-opsgenie-team-body-admin',
		defaultMessage:
			'Connect an Opsgenie team in project settings to start using on-call and incident management features in this project.',
		description:
			'Description for admin user of empty state when no Opsgenie team has been connected to this jira project',
	},
	noOpsgenieTeamBodyBasic: {
		id: 'opsgenie-schedule.common.no-opsgenie-team-body-basic',
		defaultMessage:
			'Ask your admin to connect an Opsgenie team in project settings to start using on-call and incident management features in this project.',
		description:
			'Description for basic user of empty state when no Opsgenie team has been connected to this jira project',
	},
	noOpsgenieTeamButtonAdmin: {
		id: 'opsgenie-schedule.common.no-opsgenie-team-button-admin',
		defaultMessage: 'Go to project settings',
		description:
			'Button shown to admin user when no Opsgenie team has been connected to this jira project',
	},
	noOpsgenieTeamButtonBasic: {
		id: 'opsgenie-schedule.common.no-opsgenie-team-button-basic',
		defaultMessage: 'Go to Opsgenie',
		description:
			'Button shown to basic user when no Opsgenie team has been connected to this jira project',
	},
	leaveFeedback: {
		defaultMessage: 'Give us feedback',
		id: 'opsgenie-schedule.common.leave-feedback',
		description: 'The link that allows users to give feedback',
	},
	feedbackIconLabel: {
		defaultMessage: 'Feedback',
		id: 'opsgenie-schedule.common.feedback-icon-label',
		description: 'Accessibility text used for the feedback icon',
	},
});

export default messages;
